import React, {
 useContext, useEffect, useState, useRef, 
} from 'react';
import PropTypes from 'prop-types';
import Alert from '@/shared/components/Alert';
import { Modal } from 'react-bootstrap';
import { Button } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import EditRestaurantData from './EditRestaurantData';
import { AuthContext } from '../../../../context/AuthContext';

const RejectedAgentContainer = ({ restaurantid, statusCode }) => {
    const [rejectRemark, setRejectRemark] = useState('');
    const { apiGlobal, userid, countryId } = useContext(AuthContext);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showNotify, setShowNotify] = useState(false);

    const [resInfo, setResInfo] = useState({});
    const isMounted = useRef(true); // To check if the component is still mounted

    // Define fetchAgentData before useEffect to avoid 'used before defined' error
    const fetchResData = async () => {
        const formData = new FormData();
        formData.append('id', restaurantid);
        formData.append('country_id', countryId);
        try {
            const url = await fetch(`${apiGlobal}/restaurant_data_fetch.php`, {
                method: 'POST',
                body: formData,
            });
            const response = await url.json();
            if (response.message === 'Success' && response.data.length > 0) {
                const resData = response.data[0];
                if (isMounted.current) {
                    setRejectRemark(resData.reject_reason);
                    setResInfo(resData);
                }
            } else {
                console.error('No agent data or fetch error');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchResData();
        if (statusCode === '0') {
            setShowNotify(true);
        } else if (statusCode === '2') {
            setShowNotify(false);
        }

        return () => {
            isMounted.current = false; // Cleanup on unmount
        };
    }, [statusCode]); // Added statusCode as a dependency

    const editRestaurantHandler = async (values) => {
        // console.log(JSON.stringify(values, null, 2));
        const formData = new FormData();
    formData.append('id', restaurantid);
    formData.append('user_name', values.user_name);
    formData.append('user_phone', values.user_phone);
    formData.append('user_email', values.user_email);
    formData.append('uin', values.uin);
    formData.append('country_code', values.country_code_id);
    formData.append('country', values.country);
    formData.append('acc_name', values.acc_name);
    formData.append('acc_country', values.acc_country);
    formData.append('account_no', values.account_no);
    formData.append('acc_city', values.acc_city);
    formData.append('branch', values.branch);
    formData.append('ifsc_code', values.ifsc_code);
    formData.append('bank', values.bank);
    formData.append('photo', values.file);
    formData.append('type', 1);
    formData.append('user_id', userid);

    formData.append('change_type', 1);

        try {
            const response = await fetch(`${apiGlobal}/restaurant_edit.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            console.log(data);
            if (response.status) {
                toast.success('Restaurant Edit successful!');
                setShowModalEdit(false);
                setShowNotify(true);
            } else {
                toast.error(data.message || 'Something went wrong. Please try again.');
            }
        } catch (error) {
            toast.error(`An Error Occurred: ${error.message}`);
        }
    };

    if (!restaurantid) {
        return (
          <div className="rejected-agent-container">
            Restaurant Id not Found
          </div>
        );
    }

    return (
      <div>
        {showNotify === false && (
        <div>
          <Alert color="danger" closable ButtonText="Show Remark" className="w-75">
            <p><b>Remark!</b> {rejectRemark}</p>
          </Alert>
          <Button variant="primary" onClick={() => setShowModalEdit(true)}>Edit Details</Button>
        </div>
            )}

        {showNotify && (
        <Alert color="info" colored icon>
          <p><b>Information: </b>Details are successfully sent to Admin.</p>
          <p>Contact Admin For Further Information</p>
        </Alert>
            )}

        {/* Edit Agent Modal */}
        <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Edit Restaurant</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditRestaurantData resData={resInfo} onSubmit={editRestaurantHandler} />
          </Modal.Body>
        </Modal>
      </div>
    );
};

RejectedAgentContainer.propTypes = {
    restaurantid: PropTypes.string.isRequired,
    statusCode: PropTypes.string.isRequired,
};

export default RejectedAgentContainer;
